import { createImmutableSelector } from './utils';
export const selectSiteSettingsData = state => state.siteSettings.get('data');
export const selectSiteSettingsFetched = state => state.siteSettings.get('isFetched');
export const selectSiteSettingsOverrideByDomain = createImmutableSelector([selectSiteSettingsData], siteSettings => siteSettings && siteSettings.bodyOverrideByDomain);